<div class="container-fluid" style="padding: 1rem;">
    <div [innerHTML]="htmlStr"></div>
</div>